import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { TemaService, TemaColores } from '../../../providers/tema.service';
import * as moment from 'moment';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html'
})
export class LineChartComponent implements OnInit, AfterViewInit {
  dibujarGrafico: boolean = false;
  public lineChartLabels: string[] = [];
  public lineChartData: Array<any> = [
    { data: [], label: 'Libre', backgroundColor: '', borderColor: '' },
    { data: [], label: 'Blue', backgroundColor: '', borderColor: '' }
  ];

  @Input() public set datos(datos: any[]) {
    if (datos) {
      var index = datos.length;

      while (index--) {
        this.lineChartLabels.push(moment(datos[index].fecha, "YYYY-MM-DD HH:mm:ss").format('DD/MM HH') + 'hs');
        this.lineChartData[0].data.push(datos[index].libre);
        this.lineChartData[1].data.push(datos[index].blue);
      }
    }

    this.dibujarGrafico = true;
  }

  @ViewChild(BaseChartDirective) grafico: BaseChartDirective; // referencia al objeto chart (para saber más: "ctrl + click" sobre BaseChartDirective)

  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0, // on load el gráfico no usamos animaciones
      onComplete: function (animation) {
        animation.chart.options.animation.duration = 1000; // luego del on load seteamos la animacion en 1000
      }
    },
    legend: { position: 'top', labels: {} },
    scales: {
      xAxes: [{ gridLines: {}, ticks: {} }],
      yAxes: [{ gridLines: {}, ticks: {} }]
    }
  };

  public lineChartLegend = true;
  public lineChartType = 'line';

  constructor(
    private temaService: TemaService
  ) { }

  ngOnInit(): void {
    this.temaService.temaChange.subscribe((temaNuevo: TemaColores) => {
      this.actualizarColores(temaNuevo);
    });
  }

  ngAfterViewInit(): void {
    // inicializar grafico con los colores del tema seleccionado
    this.actualizarColores(this.temaService.getColores());
  }

  actualizarColores(colores: TemaColores): void {
    // aplicar los options del grafico  
    if (this.grafico) {
      this.chartColors(
        'cool',
        colores.foreground.getPropertyValue('color'),
        colores.foreground.getPropertyValue('background-color')
      );
    }
  }

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }

  chartColors(palette, labelColor, borderColor) {
    /*Gradients
      The keys are percentage and the values are the color in a rgba format.
      You can have as many "color stops" (%) as you like.
      0% and 100% is not optional.*/
    var gradient;
    switch (palette) {
      case 'cool':
        gradient = {
          0: [0, 192, 239, 1],
          20: [0, 166, 90, 1],
          45: [243, 156, 17, 1],
          65: [221, 76, 57, 1],
          100: [0, 0, 0, 1]
        };
        break;
      case 'warm':
        gradient = {
          0: [255, 255, 255, 1],
          20: [254, 235, 101, 1],
          45: [228, 82, 27, 1],
          65: [77, 52, 47, 1],
          100: [0, 0, 0, 1]
        };
        break;
      case 'neon':
        gradient = {
          0: [255, 255, 255, 1],
          20: [255, 236, 179, 1],
          45: [232, 82, 133, 1],
          65: [106, 27, 154, 1],
          100: [0, 0, 0, 1]
        };
        break;
    }

    //Get a sorted array of the gradient keys
    var gradientKeys = Object.keys(gradient);
    gradientKeys.sort(function (a, b) {
      return +a - +b;
    });

    //Find datasets and length
    var chartType;
    if (this.grafico.chart) {
      chartType = this.grafico.chart.config.type;

      switch (chartType) {
        case "pie":
        case "doughnut":
          // color a los labels
          this.grafico.chart.options.legend.labels.fontColor = labelColor;

          // color a los datos
          var datasets = this.grafico.chart.config.data.datasets[0];
          var setsCount = datasets.data.length;
          break;
        case "bar":
        case "line":
          // color a los labels y ejes
          this.lineChartOptions.legend.labels.fontColor = labelColor;
          this.lineChartOptions.scales.xAxes[0].gridLines.zeroLineColor = borderColor;
          this.lineChartOptions.scales.xAxes[0].gridLines.color = borderColor;
          this.lineChartOptions.scales.xAxes[0].ticks.fontColor = borderColor;
          this.lineChartOptions.scales.yAxes[0].gridLines.zeroLineColor = borderColor;
          this.lineChartOptions.scales.yAxes[0].gridLines.color = borderColor;
          this.lineChartOptions.scales.yAxes[0].ticks.fontColor = borderColor;
          this.grafico.ngOnInit();

          // color a los datos
          var datasets = this.grafico.chart.config.data.datasets;
          var setsCount = datasets.length;
          break;
      }

      //Calculate colors
      var chartColors = [];
      for (let i = 0; i < setsCount; i++) {
        var gradientIndex = (i + 1) * (100 / (setsCount + 1)); //Find where to get a color from the gradient
        for (let j = 0; j < gradientKeys.length; j++) {
          var gradientKey = gradientKeys[j];
          if (gradientIndex === +gradientKey) { //Exact match with a gradient key - just get that color
            chartColors[i] = 'rgba(' + gradient[gradientKey].toString() + ')';
            break;
          } else if (gradientIndex < +gradientKey) { //It's somewhere between this gradient key and the previous
            var prevKey = gradientKeys[j - 1];
            var gradientPartIndex = (gradientIndex - (+prevKey)) / ((+gradientKey) - (+prevKey)); //Calculate where
            var color = [];
            for (let k = 0; k < 4; k++) { //Loop through Red, Green, Blue and Alpha and calculate the correct color and opacity
              color[k] = gradient[prevKey][k] - ((gradient[prevKey][k] - gradient[gradientKey][k]) * gradientPartIndex);
              if (k < 3) color[k] = Math.round(color[k]);
            }
            chartColors[i] = 'rgba(' + color.toString() + ')';
            break;
          }
        }
      }

      //Copy colors to the chart
      for (let i = 0; i < setsCount; i++) {
        switch (chartType) {
          case "pie":
          case "doughnut":
            if (!datasets.backgroundColor) datasets.backgroundColor = [];
            datasets.backgroundColor[i] = chartColors[i];
            if (!datasets.borderColor) datasets.borderColor = [];
            datasets.borderColor[i] = borderColor;
            if (!datasets.borderWidth) datasets.borderWidth = [];
            datasets.borderWidth[i] = 1;
            break;
          case "bar":
            datasets[i].backgroundColor = chartColors[i];
            datasets[i].borderColor = "rgba(255,255,255,0)";
            break;
          case "line":
            datasets[i].borderColor = chartColors[i];

            // seteamos el background
            var coloresRBG = chartColors[i].replace('rgba(', '').replace(')', '').split(',');
            coloresRBG.splice(3, 1);
            datasets[i].backgroundColor = 'rgba(' + coloresRBG.join(',') + ', 0.07)';

            this.lineChartData = datasets;
            break;
        }
      }
    }
  }
}